export const validateItems = (items) => {
  if (!Array.isArray(items) || items.length === 0) {
    return "At least one laundry item is required";
  }

  const rowErrors = [];

  items.forEach((item, index) => {
    const err = {};

    if (!item.product_id) {
      err.product_id = "Product is required";
    }

    if (!item.task_id || item.task_id.length === 0) {
      err.task_id = "Select at least one task";
    }

    if (!item.quantity || Number(item.quantity) <= 0) {
      err.quantity = "Quantity must be greater than 0";
    }

    if (Object.keys(err).length > 0) {
      rowErrors[index] = err;
    }
  });

  return rowErrors.length ? rowErrors : null;
};
